interface IconProps {
	size?: number;
	color?: string;
}

const Language = ({ size = 48, color = '#fff' }: IconProps) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={size}
			height={size}
			viewBox='0 0 38 38'
			fill={color}
		>
			<path
				fill={color}
				fillRule='evenodd'
				d='M18 0c4.775 0 9.351 1.897 12.729 5.271a18.006 18.006 0 0 1 0 25.457 18.006 18.006 0 0 1-12.282 5.266L18 36A18.019 18.019 0 0 1 .006 18.447L0 18c0-4.775 1.897-9.351 5.271-12.729A18.006 18.006 0 0 1 18 0Zm-4.532 30.35c1.033 1.763 2.233 2.902 3.468 3.32v-3.32h-3.468Zm5.596 3.32c1.235-.418 2.436-1.557 3.468-3.32h-3.468v3.32ZM8.07 30.35a15.838 15.838 0 0 0 4.508 2.545 12.867 12.867 0 0 1-1.586-2.544H8.07Zm16.937 0a12.88 12.88 0 0 1-1.587 2.545 15.843 15.843 0 0 0 4.51-2.544h-2.923ZM2.186 19.065a15.778 15.778 0 0 0 3.706 9.158h4.222a29.805 29.805 0 0 1-1.627-9.158H2.186Zm8.433 0a27.184 27.184 0 0 0 1.818 9.158h4.499v-9.158h-6.317Zm8.445 9.158h4.5a27.184 27.184 0 0 0 1.817-9.158h-6.317v9.158Zm8.448-9.158a29.807 29.807 0 0 1-1.626 9.158h4.222a15.78 15.78 0 0 0 3.707-9.158h-6.303ZM5.892 7.778a15.779 15.779 0 0 0-3.706 9.158h6.302c.06-3.12.608-6.21 1.626-9.158H5.892Zm6.545 0a27.183 27.183 0 0 0-1.819 9.158h6.318V7.778h-4.5Zm6.627 9.158h6.317a27.183 27.183 0 0 0-1.819-9.158h-4.498v9.158Zm6.82-9.158a29.808 29.808 0 0 1 1.628 9.158h6.301a15.777 15.777 0 0 0-3.706-9.158h-4.222ZM12.58 3.104A15.839 15.839 0 0 0 8.07 5.649h2.922c.429-.909.962-1.763 1.587-2.545Zm4.357-.776c-1.235.419-2.435 1.56-3.468 3.321h3.468V2.33Zm2.128 3.321h3.467C21.5 3.888 20.3 2.747 19.065 2.33v3.32Zm4.356-2.545a12.88 12.88 0 0 1 1.587 2.545h2.923a15.845 15.845 0 0 0-4.51-2.545Z'
				clipRule='evenodd'
			/>
		</svg>
	);
};

export default Language;
